"use strict";

app.Product = {
    mounted: function mounted() {
        $(window).off("UPDATE_PRODUCT_DATA").on("UPDATE_PRODUCT_DATA", this.updateProductData.bind(this));
    },
    update: function update() {},
    getData: function getData() {
        return {
            has_hdpicture: false,
            has_gd: false,
            has_dilatationcurves: false,
            tooltip: true,
            description: true,
            gd_sharepoint_url: null
        };
    },
    dispose: function dispose() {
        $(window).off("UPDATE_PRODUCT_DATA", this.updateProductData.bind(this));
    },
    getTitle: function getTitle() {
        if (app.Data.data.platform == 'VeralliaCom') {
            return app.Data.data.loc.interface.title_veralliacom;
        } else if (app.Data.data.platform == 'MyVerallia') {
            return app.Data.data.loc.interface.title_myverallia + " " + app.Data.data.loc.global.countries[app.Data.data.config.country.toLowerCase()].label;
        } else if (app.Data.data.platform == 'ICTPLS') {
            return app.Data.data.loc.interface.title_pls;
        } else {
            return app.Data.data.loc.interface.title_ict;
        }
    },
    goToOrder: function goToOrder() {
        $("html, body").animate({ scrollTop: $(document).height() }, 1000);
    },

    updateProductData: function updateProductData() {
        setTimeout(updatePalettes, 200);
        function updatePalettes() {
            //$("#ct_product_details .nano").nanoScroller();
            $(window).trigger("UPDATE_PRODUCT_PALETTES_DATA");
        }

        //app.Data.data.product_section = 0;

        trace(verallia.ObjectUtils.copy(app.Data.data.baseproduct));
        this.checkFinishedProducts();
        this.checkFiles();
    },
    closeProduct: function closeProduct() {
        app.Data.data.baseproduct = null;
        app.Data.data.section = "products";
        verallia.Core.getObject("app").updateHash();
        verallia.Core.getObject("filters").updateDisplay();
    },
    openProduct: function openProduct(id, index) {
        this.has_hdpicture = false;
        this.has_gd = false;
        this.has_dilatationcurves = false;

        app.Data.data.baseproduct = app.Data.data.baseproducts[id];
        app.Data.data.baseproduct.selected_index = index;
        app.Data.data.section = "product";
        verallia.Core.getObject("app").updateHash();
        $(window).trigger("UPDATE_PRODUCT_PALETTES_DATA");

        trace(verallia.ObjectUtils.copy(app.Data.data.baseproduct));

        this.checkFinishedProducts();
        this.checkFiles();
    },
    checkMTO: function checkMTO(baseproduct) {
        return app.Utils.checkMTO(baseproduct, baseproduct.selected_index);
    },

    openPictureHD: function openPictureHD() {
        var product = app.Data.data.baseproduct.pr[app.Data.data.baseproduct.selected_index];

        if (!app.Data.data.baseproduct.competitor) {
            verallia.WindowUtils.openURL(app.Data.data.config.products_images_directory + "zoom/" + product.cb + ".jpg", "_blank");
        }
    },
    openGD: function openGD() {
        if (app.Data.data.platform == "VeralliaCom") {
            var url;
            if (app.Data.data.config.country.toLowerCase() == "fr" && app.Data.data.config.language == "fr") url = "https://fr.verallia.com/s/login/?language=fr";else if (app.Data.data.config.country.toLowerCase() == "fr" && app.Data.data.config.language == "en") url = "https://fr.verallia.com/s/login/?language=en";else if (app.Data.data.config.country.toLowerCase() == "de" && app.Data.data.config.language == "de") url = "https://de.verallia.com/s/login/?language=de";else if (app.Data.data.config.country.toLowerCase() == "de" && app.Data.data.config.language == "en") url = "https://de.verallia.com/s/login/?language=en";else if (app.Data.data.config.country.toLowerCase() == "sp" && app.Data.data.config.language == "es") url = "https://es.verallia.com/s/login/?language=es";else if (app.Data.data.config.country.toLowerCase() == "sp" && app.Data.data.config.language == "en") url = "https://es.verallia.com/s/login/?language=en";else if (app.Data.data.config.country.toLowerCase() == "br" && app.Data.data.config.language == "pt") url = "https://br.verallia.com/s/login/?language=pt_BR";else if (app.Data.data.config.country.toLowerCase() == "br" && app.Data.data.config.language == "en") url = "https://br.verallia.com/s/login/?language=en";else if (app.Data.data.config.country.toLowerCase() == "it" && app.Data.data.config.language == "it") url = "https://it.verallia.com/s/login/?language=it";else if (app.Data.data.config.country.toLowerCase() == "it" && app.Data.data.config.language == "en") url = "https://it.verallia.com/s/login/?language=en";else if (app.Data.data.config.country.toLowerCase() == "pt" && app.Data.data.config.language == "pt") url = "https://pt.verallia.com/s/login/?language=pt";else if (app.Data.data.config.country.toLowerCase() == "pt" && app.Data.data.config.language == "en") url = "https://pt.verallia.com/s/login/?language=en";else if (app.Data.data.config.country.toLowerCase() == "ar" && app.Data.data.config.language == "es") url = "https://ar.verallia.com/s/login/?language=es_AG";else if (app.Data.data.config.country.toLowerCase() == "ar" && app.Data.data.config.language == "en") url = "https://ar.verallia.com/s/login/?language=en";else if (app.Data.data.config.country.toLowerCase() == "ua" && app.Data.data.config.language == "uk") url = "https://ua.verallia.com/s/login/?language=uk";else if (app.Data.data.config.country.toLowerCase() == "ua" && app.Data.data.config.language == "en") url = "https://ua.verallia.com/s/login/?language=en";else if (app.Data.data.config.country.toLowerCase() == "cl" && app.Data.data.config.language == "es") url = "https://cl.verallia.com/s/login/?language=es_CL";else if (app.Data.data.config.country.toLowerCase() == "cl" && app.Data.data.config.language == "en") url = "https://cl.verallia.com/s/login/?language=en";else if (app.Data.data.config.country.toLowerCase() == "ru" && app.Data.data.config.language == "ru") url = "https://ru.verallia.com/s/login/?language=es_CL";else if (app.Data.data.config.country.toLowerCase() == "ru" && app.Data.data.config.language == "en") url = "https://ru.verallia.com/s/login/?language=en";else url = "https://verallia.force.com/France/s/login/?language=en";

            verallia.WindowUtils.openURL(url, "_blank");
            return;
        }

        // if(app.Data.data.platform == "VeralliaCom"){
        //     var url;
        //     if(app.Data.data.config.country.toLowerCase() == "fr" && app.Data.data.config.language == "fr") url = "http://www.myverallia.com/Web_LoginPage?lang=fr";
        //     else if(app.Data.data.config.country.toLowerCase() == "de" && app.Data.data.config.language == "de") url = "http://www.myverallia.com/Web_LoginPage?lang=de";
        //     else if(app.Data.data.config.country.toLowerCase() == "sp" && app.Data.data.config.language == "es") url = "http://www.myverallia.com/Web_LoginPage?lang=es";
        //     else if(app.Data.data.config.country.toLowerCase() == "br" && app.Data.data.config.language == "pt") url = "http://www.myverallia.com/Web_LoginPage?lang=pt_BR";
        //     else if(app.Data.data.config.country.toLowerCase() == "it" && app.Data.data.config.language == "it") url = "http://www.myverallia.com/Web_LoginPage?lang=it";
        //     else if(app.Data.data.config.country.toLowerCase() == "pt" && app.Data.data.config.language == "pt") url = "http://www.myverallia.com/Web_LoginPage?lang=pt_PT";
        //     else url = "http://www.myverallia.com/Web_LoginPage?lang=en";

        //     verallia.WindowUtils.openURL(url, "_blank");
        //     return;
        // }

        var product = app.Data.data.baseproduct.pr[app.Data.data.baseproduct.selected_index];
        //var gd_without_version = app.Utils.getGDWithoutVersion(app.Data.data.baseproduct);

        var meteor_check = true;
        if (window.location.href.indexOf("appsdev.corp.inpkg.net") != -1 || window.location.href.indexOf("appsqual.corp.inpkg.net") != -1 || window.location.href.indexOf("apps.corp.inpkg.net") != -1) meteor_check = true;

        if (!app.Data.data.baseproduct.competitor) {
            if (meteor_check == false) {
                verallia.WindowUtils.openURL(app.Data.data.config.products_docs_directory + "GlassDrawings/" + app.Data.data.baseproduct.gd + ".pdf", "_blank");
            } else {
                //verallia.WindowUtils.openURL(app.Data.data.config.products_docs_directory + "GlassDrawings/" + app.Data.data.baseproduct.gd + ".pdf", "_blank");
                verallia.WindowUtils.openURL(this.gd_sharepoint_url.gd, "_blank");
            }
        } else {
            verallia.WindowUtils.openURL(app.Data.data.config.competitors_products_docs_directory + product.br + '/' + product.cb + '.pdf', "_blank");
        }
    },
    openDilatationCurves: function openDilatationCurves() {
        var product = app.Data.data.baseproduct.pr[app.Data.data.baseproduct.selected_index];

        var meteor_check = true;
        if (window.location.href.indexOf("appsdev.corp.inpkg.net") != -1 || window.location.href.indexOf("appsqual.corp.inpkg.net") != -1 || window.location.href.indexOf("apps.corp.inpkg.net") != -1) meteor_check = true;

        if (!app.Data.data.baseproduct.competitor) {
            if (meteor_check == false) {
                verallia.WindowUtils.openURL(app.Data.data.config.products_docs_directory + "DilatationCurves/C_" + app.Data.data.baseproduct.gds + ".pdf", "_blank");
            } else {
                //verallia.WindowUtils.openURL(app.Data.data.config.products_docs_directory + "DilatationCurves/C_" + app.Data.data.baseproduct.gds + ".pdf", "_blank");
                verallia.WindowUtils.openURL(this.gd_sharepoint_url.gds, "_blank");
            }
        }
    },
    checkFiles: function checkFiles() {
        if (!this.baseproduct && app.Data.data.section != "product") return;

        if (app.Data.data.platform == "VeralliaCom") {
            this.has_gd = true;
            return;
        }

        this.gd_sharepoint_url = { gd: null, gds: null };
        this.has_hdpicture = false;
        this.has_gd = false;
        this.has_dilatationcurves = false;
        var product = app.Data.data.baseproduct.pr[app.Data.data.baseproduct.selected_index];
        //var gd_without_version = app.Utils.getGDWithoutVersion(app.Data.data.baseproduct);

        //trace("checking gd without vrsion : " + gd_without_version);

        var meteor_check = false;
        if (window.location.href.indexOf("appsdev.corp.inpkg.net") != -1 || window.location.href.indexOf("appsqual.corp.inpkg.net") != -1 || window.location.href.indexOf("apps.corp.inpkg.net") != -1) meteor_check = true;

        meteor_check = true;

        if (!app.Data.data.baseproduct.competitor) {
            if (app.Data.data.platform != "MyVerallia") {
                this.checkFile("hdpicture", app.Data.data.config.products_images_directory + "zoom/" + product.cb + ".jpg");
            } else {
                try {
                    //if(mv_can_access_hd_picture == true || mv_can_access_hd_picture  == "true") this.checkFile("hdpicture", app.Data.data.config.products_images_directory + "zoom/" + product.cb + ".jpg");
                    this.checkFile("hdpicture", app.Data.data.config.products_images_directory + "zoom/" + product.cb + ".jpg");
                } catch (e) {}
            }

            if (meteor_check == false) {
                if (app.Data.data.baseproduct.gd && app.Data.data.baseproduct.gd != "null") this.checkFile("gd", app.Data.data.config.products_docs_directory + "GlassDrawings/" + app.Data.data.baseproduct.gd + ".pdf");
                if (app.Data.data.baseproduct.gds && app.Data.data.baseproduct.gds != "null") this.checkFile("dilatationcurves", app.Data.data.config.products_docs_directory + "DilatationCurves/C_" + app.Data.data.baseproduct.gds + ".pdf");
            } else {
                var beforeSendToken = function beforeSendToken(xhr) {
                    xhr.setRequestHeader("Authorization", "Bearer " + app.Data.data.access_token);
                };

                //if(app.Data.data.platform != "MyVerallia"){


                $.ajax({ method: "GET", url: app.Data.data.config.products_docs_sharepoint_file_api + "GlassDrawings/" + app.Data.data.baseproduct.gd + ".pdf", beforeSend: beforeSendToken }).done(this.checkGDCall);
                $.ajax({ method: "GET", url: app.Data.data.config.products_docs_sharepoint_file_api + "DilatationCurves/C_" + app.Data.data.baseproduct.gds + ".pdf", beforeSend: beforeSendToken }).done(this.checkGDSCall);
                /*}else{
                    $.ajax({ method:"GET", url:app.Data.data.config.products_docs_sharepoint_file_api + "GlassDrawings/" + app.Data.data.baseproduct.gd + ".pdf", beforeSend:beforeSendToken }).done(this.checkGDCall);
                    $.ajax({ method:"GET", url:app.Data.data.config.products_docs_sharepoint_file_api + "DilatationCurves/C_" + app.Data.data.baseproduct.gds + ".pdf", beforeSend:beforeSendToken }).done(this.checkGDSCall);
                }*/
            }
        } else {
            this.checkFile("gd", app.Data.data.config.competitors_products_docs_directory + product.br + '/' + product.cb + '.pdf');
        }
    },

    checkFile: function checkFile(value, url) {
        var t = this;
        //$.ajax({ type: 'HEAD', url:url, success:completeHead })

        fetch(url, { method: "HEAD" }).then(function (response) {
            if (response.status == 200) {
                t["has_" + value] = true;
                //t.$forceUpdate();
            }
        });

        // function completeHead(message, text, response){
        //     if(response.status == 200){
        //         t["has_" + value] = true;
        //         //t.$forceUpdate();
        //     }
        // }
    },
    checkGDCall: function checkGDCall(result) {
        if (result && result.status == "success") {
            this.has_gd = true;
            this.gd_sharepoint_url.gd = result.data["@microsoft.graph.downloadUrl"];
        }
    },
    checkGDSCall: function checkGDSCall(result) {
        if (result && result.status == "success") {
            this.has_dilatationcurves = true;
            this.gd_sharepoint_url.gds = result.data["@microsoft.graph.downloadUrl"];
        }
    },
    openVG: function openVG() {
        $(window).trigger("OPEN_VG", this.baseproduct);
    },

    compare: function compare() {
        if (app.Data.data.comparator_products[app.Data.data.baseproduct.id]) this.$delete(app.Data.data.comparator_products, app.Data.data.baseproduct.id);else this.$set(app.Data.data.comparator_products, app.Data.data.baseproduct.id, { id: app.Data.data.baseproduct.id, index: app.Data.data.baseproduct.selected_index });

        verallia.LocalStorageUtils.setKey("ct_comparator" + app.Data.data.platform, JSON.stringify(app.Data.data.comparator_products));

        $(window).trigger("COMPARATOR_UPDATE");
    },
    sendToSamples: function sendToSamples() {
        if (app.Data.data.samples_products[app.Data.data.baseproduct.id]) this.$delete(app.Data.data.samples_products, app.Data.data.baseproduct.id);else this.$set(app.Data.data.samples_products, app.Data.data.baseproduct.id, { id: app.Data.data.baseproduct.id, index: app.Data.data.baseproduct.selected_index, quantity: 1 });

        verallia.LocalStorageUtils.setKey("ct_samples" + app.Data.data.platform, JSON.stringify(app.Data.data.samples_products));

        $(window).trigger("SAMPLES_UPDATE");
    },
    selectBottle: function selectBottle() {
        $(window).trigger("SELECT_BOTTLE", this.baseproduct);
    },
    openContact: function openContact() {
        if (app.Data.data.platform == "MyVerallia") {
            try {
                var fip = app.Data.data.baseproduct.pr[app.Data.data.baseproduct.selected_index].fip;
                var index = app.Data.data.baseproduct.pr[app.Data.data.baseproduct.selected_index].selected_line;
                var label = app.Data.data.baseproduct.la;

                trace("opening contact form with: ");
                trace("baseproduct: " + app.Data.data.baseproduct.pr[app.Data.data.baseproduct.selected_index].cb + " " + label);
                if (fip[index]) trace("finished product: " + fip[index].cf);

                if (fip[index]) contactForm(app.Data.data.baseproduct.pr[app.Data.data.baseproduct.selected_index].cb, fip[index].cf, label);else contactForm(app.Data.data.baseproduct.pr[app.Data.data.baseproduct.selected_index].cb, null, label);
            } catch (e) {}
        } else if (app.Data.data.platform == "VeralliaCom") {
            var country = app.Data.data.config.country.toLowerCase();
            var language = app.Data.data.config.language.toLowerCase();
            var url = app.Data.data.config.myverallia_contact_form_url[country][language];
            //var url = app.Data.data.config.myverallia_contact_url[country][language]; //OLD URL

            url = verallia.StringUtils.replace(url, "{{PRODUCT_CODE}}", app.Data.data.baseproduct.pr[app.Data.data.baseproduct.selected_index].cb);
            url = verallia.StringUtils.replace(url, "{{PRODUCT_NAME}}", app.Data.data.baseproduct.la);

            verallia.WindowUtils.openURL(url, "_blank");
        }

        return;

        var country = app.Data.data.config.country.toLowerCase();
        var language = app.Data.data.config.language.toLowerCase();
        var url = app.Data.data.config.myverallia_contact_url[country][language];

        url += "?compare=0";
        url += "&product=" + app.Data.data.baseproduct.pr[app.Data.data.baseproduct.selected_index].cb + " - " + app.Data.data.baseproduct.la;
        url += "&range=" + app.Data.data.baseproduct.ga[0].la;
        url += "&capacity=" + app.Data.data.baseproduct.vo;
        url += "&color=" + app.Data.data.baseproduct.pr[app.Data.data.baseproduct.selected_index].cl;

        verallia.WindowUtils.openURL(url, "_blank");
    },
    checkFinishedProducts: function checkFinishedProducts() {
        var metaproduct = app.Data.data.baseproduct;

        if (app.Data.data.platform == "ICT") {
            if (!metaproduct.pr[metaproduct.selected_index].fp_checked) {

                var url = app.Data.data.config.finished_products_url + metaproduct.pr[metaproduct.selected_index].cb;
                // RAJOUTER ICI LES SALESORG DANS L'URL
                // Celle du pays quand on est en mode national et tous les pays quand on est en mode international
                if (metaproduct.pr[metaproduct.selected_index].salesOrg && metaproduct.pr[metaproduct.selected_index].salesOrg.length != 0) {
                    var a = metaproduct.pr[metaproduct.selected_index].salesOrg.length;
                    for (var i = 0; i < a; i++) {
                        var so = metaproduct.pr[metaproduct.selected_index].salesOrg[i];

                        //url += "&salesOrg=" + so;
                    }
                } else if (metaproduct.pr[metaproduct.selected_index].so && metaproduct.pr[metaproduct.selected_index].so != "") {
                    //url += "&salesOrg=" + metaproduct.pr[metaproduct.selected_index].so;
                }

                $.ajax({ method: "GET", url: url, complete: this.setFIP.bind(this) });
            } else {
                var updatePalettes = function updatePalettes() {
                    $(window).trigger("UPDATE_FINISHED_PRODUCTS_DATA");
                    $(window).trigger("UPDATE_FINISHED_PRODUCTS_STOCK_DATA");
                };

                setTimeout(updatePalettes, 200);
            }
        }
    },
    setFIP: function setFIP(data) {
        var metaproduct = app.Data.data.baseproduct;

        if (!metaproduct) return;

        var bp = metaproduct.pr[metaproduct.selected_index];
        bp.fp_checked = true;

        var fip;
        try {
            if (data.responseJSON.status == "success" && data.responseJSON.data) fip = data.responseJSON.data;
        } catch (e) {}

        if (fip && fip.length != 0 && fip[0].baseProduct == bp.cb) {
            var updatePalettes = function updatePalettes() {
                $(window).trigger("UPDATE_FINISHED_PRODUCTS_DATA");
                $(window).trigger("UPDATE_FINISHED_PRODUCTS_STOCK_DATA");
            };

            bp.fip = [];
            bp.selected_line = 0;

            var a = fip.length;
            for (var i = 0; i < a; i++) {
                if (app.Data.data.pf_exclude.indexOf(fip[i]._id) != -1) continue;

                fip[i].id = fip[i]._id;
                fip[i].display = true;
                //remove decored finished products in ICT
                if (app.Data.data.platform == "ICT" && fip[i].materialGroup) {
                    if (fip[i].materialGroup.toLowerCase() == "naac" || fip[i].materialGroup.toLowerCase() == "naaa") fip[i].display = true;else fip[i].display = false;
                }
                if (app.Data.data.platform == "ICT" && !fip[i].materialGroup) fip[i].display = false;
                //if(app.Data.data.platform == "ICT" && fip[i].status && fip[i].status.toLowerCase() == "z3") fip[i].display = false;
                if (app.Data.data.platform == "ICT" && fip[i].status && fip[i].status.toLowerCase() == "z1") fip[i].display = false;

                var status = ["st", "sr"];
                if (app.Data.data.platform == "ICT" && fip[i].standard && status.indexOf(fip[i].standard.toLowerCase()) == -1) fip[i].display = false;
                if (app.Data.data.platform == "ICT" && !fip[i].standard) fip[i].display = false;
                fip[i].quantity = 1;

                //app.Data.data.finishedproducts[fip[i]._id] = fip[i];
                bp.fip.push(fip[i]);
            }

            this.$forceUpdate();

            setTimeout(updatePalettes, 200);
        }
    },
    sectionChange: function sectionChange() {
        if (app.Data.data.product_section == 1) {
            var updateStocks = function updateStocks() {
                $(window).trigger("UPDATE_FINISHED_PRODUCTS_STOCK_DATA");
            };

            setTimeout(updateStocks, 200);
        }
    },
    setProductSection: function setProductSection(section) {
        app.Data.data.product_section = section;
        verallia.Core.getObject("app").updateHash();
    },
    checkPFavailability: function checkPFavailability() {
        //if(app.Data.data.platform == "ICT" && window.location.href.indexOf("apps.corp.inpkg.net") == -1) return true;
        if (app.Data.data.platform == "ICT") return true;

        return false;
    }
};